import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CONTACT_URL } from '../config';
import Card from './Card';

const propTypes = {};

function ContactCardFooter() {
  return (
    <Card.Footer>
      <FormattedMessage id="login.questions" defaultMessage="Questions?" />{' '}
      <a href={CONTACT_URL}>
        <FormattedMessage id="login.contact" defaultMessage="Contact us" />
      </a>
    </Card.Footer>
  );
}

ContactCardFooter.propTypes = propTypes;

export default ContactCardFooter;
